// @need-translate
export function SafeGuard() {
  return (
    <>
      <header>카카오페이지 청소년보호정책</header>
      <main>
        <p>
          카카오페이지는 청소년을 유해 정보로부터 보호하고 안전한 인터넷 사용을
          보장하기 위해 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」과
          「청소년 보호법」에 근거한 청소년 보호정책을 시행하고 있습니다.
          카카오페이지의 청소년 보호 정책은 청소년을 만 19세 미만의 사람으로
          정의하며, 만 19세가 되는 해의 1월 1일을 맞이한 사람은 성인으로
          간주합니다.
        </p>
        <div>
          <section>
            <h3>1. 청소년 보호를 위한 목표 및 기본 원칙</h3>
            <p>
              청소년이 정신적·신체적으로 유해한 환경으로부터 보호받고 건전하게
              성장할 수 있도록 노력하며, 안전하게 인터넷을 이용할 수 있는
              서비스를 제공하기 위해 청소년보호정책을 명시하고 있습니다.
            </p>
          </section>
          <section>
            <h3>2. 청소년유해정보에 대한 청소년 보호 장치 및 관리조치</h3>
            <p>
              청소년이 아무런 제한 없이 유해 정보에 노출되지 않도록,
              청소년유해매체물에는 연령 인증 장치를 마련하여 적용하고 있습니다.
              또한 성인 인증 장치가 마련된 서비스는 이용 범위를 제한하는 등
              철저히 관리하고 있으며, 불법적이거나 청소년에게 유해한 키워드와
              콘텐츠에 대해서도 지속적으로 모니터링하고 있습니다.
              <br /> 카카오페이지는 청소년에게 유해한 정보를 명확히 정의하고
              철저히 관리합니다. 성적·폭력적·범죄적 요소나 도박, 약물 남용 등
              청소년의 정신적·신체적 건강과 건전한 성장을 저해할 수 있는 모든
              내용을 청소년에게 유해한 정보로 규정하고, 이에 해당하는 정보의
              유통을 사전에 차단하기 위해 내부 심의와 모니터링 절차를 강화하고
              있습니다.
            </p>
          </section>
          <section>
            <h3>3. 청소년유해정보로 인한 피해상담 및 고충처리</h3>
            <p>
              유해정보로 인한 피해상담 및 고충처리를 위한 전문인력을 배치하여
              피해가 확산되지 않도록 하고 있으며, 하단의 청소년 보호 책임자의
              소속 및 성명, 연락처를 참고하시어 피해상담 및 고충처리를 요청하실
              수도 있습니다. 또한 자체적으로 처리가 곤란할 경우 피해 관련기관을
              안내해 드리고 있습니다.
            </p>
          </section>
          <section>
            <h3>4. 유해정보로부터 청소년을 보호하기 위한 교육</h3>
            <p>
              청소년보호담당자 및 각 서비스 담당자들을 대상으로 청소년 보호를
              위한 각종 관련 법령 및 제재기준, 유해정보 발견 시 대처방법,
              위반사항 처리에 대한 보고절차 등을 교육하고 있습니다.
            </p>
          </section>
          <section>
            <h3>5. 청소년보호책임자 및 담당자의 지정</h3>
            <p>
              아래와 같이 청소년보호책임자 및 청소년보호담당자를 지정하여
              청소년유해정보의 차단 및 관리, 청소년유해정보로부터의
              청소년보호정책을 수립하는 등 건전한 인터넷 환경을 조성하기 위한
              제반 활동을 전개합니다.
              <br /> 카카오페이지는 아동·청소년과 관련된 신규 서비스를
              출시하거나 기존 서비스를 개편하는 경우 아동·청소년 리스크 점검
              절차를 철저히 운영하고 있습니다. 서비스 담당자가 작성한 점검
              결과는 청소년 보호 책임자의 검토와 경영진 보고·승인을 거치는
              절차를 내재화하였으며, 그 점검 결과는 카카오 그룹의 기술윤리를
              담당하고 있는 조직에서 관리하고 있습니다.
              <br />
              또한, 아동·청소년에게 미칠 수 있는 영향을 사전에 검토하기 위해
              국제 아동정책기관 유니세프의 디지털아동영향평가를 참고하여 점검
              도구를 개발하였으며, 이를 통해 국제표준과 국내 법·정책을 균형 있게
              반영하고자 노력하고 있습니다.
              <br />
              아울러, 카카오페이지는 아동·청소년 리스크를 ‘정책 및 거버넌스 구축
              → 리스크 점검 및 완화 조치 → 고충처리 제도 운영’으로 이어지는
              통합된 순환체계 안에서 관리합니다.
              <br />
              앞으로도 카카오페이지는 안전하고 신뢰할 수 있는 인터넷 환경을
              조성하여, 청소년이 올바른 콘텐츠를 통해 건강한 문화 속에서 성장할
              수 있도록 꾸준히 노력하겠습니다.
            </p>
          </section>
        </div>
        <section>
          <div>
            <p>[청소년 보호 책임자]</p>
            <p>
              이름 : 송진우
              <br />
              소속 : 스토리플랫폼사업본부
              <br />
              직위 : 본부장
              <br />
              전화 : 1644-4755
              <br />
              문의하기 : support@kakaopage.com
            </p>
          </div>
        </section>
        <section>
          <div>
            <p>[청소년 보호 담당자]</p>
            <p>
              이름 : 김지란
              <br />
              소속 : 플랫폼지원팀
              <br />
              직위 : 팀원
              <br />
              전화 : 1644-4755
              <br />
              문의하기 : support@kakaopage.com
            </p>
          </div>
        </section>
      </main>
      <footer>
        <p>이 약관은 2025년 10월 27일부터 적용됩니다.</p>
      </footer>
    </>
  );
}
